import React from "react";
//#region redux
import { ThunkDispatch } from "redux-thunk";
import { useDispatch } from "react-redux";
import { annualReportSigned } from "store/actions/annualReportAuditorSigningStepsActions";
//#endregion
//#region Types
import { StyleEnums } from "models/enums";
import { AnnualReportAuditorSigningStepsFooterProps } from "models/propTypes/annualAccountPropTypes";
import { TranslationKeys } from "translations";
import { WintSuperkollAPIModel, WintSuperkollAPIModelAnnualAccounts } from "wint-api-client/dist/types";
//#endregion
//#region Components
import { PageFooter } from "components/common";
import { useAnnualAccountService, useTodoService } from "serviceHooks";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const AnnualReportAuditorSigningStepsFooter: React.FC<AnnualReportAuditorSigningStepsFooterProps> = (props) => {
  const { annualAccountReport } = props;
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();
  const todoService = useTodoService();
  const annualAccountService = useAnnualAccountService();

  const navigateToSigningPage = async () => {
    let signingUrl = "https://arsredovisning.bolagsverket.se/arsredovisning-ingivning-web/";

    if (
      annualAccountReport?.state ===
      WintSuperkollAPIModelAnnualAccounts.SuperkollAnnualReportState.AnnualReportSigningStarted
    ) {
      signingUrl = `https://app.oneflow.com/documents/${annualAccountReport.contract?.externalId}/at/${annualAccountReport.accessLink}`;
    } else if (
      annualAccountReport?.state ===
      WintSuperkollAPIModelAnnualAccounts.SuperkollAnnualReportState.GeneralMeetingSigningStarted
    ) {
      signingUrl = `https://app.oneflow.com/documents/${annualAccountReport.contract?.externalId}/at/${annualAccountReport.accessLink}`;
    } else if (
      annualAccountReport?.state === WintSuperkollAPIModelAnnualAccounts.SuperkollAnnualReportState.XbrlFileSubmitted
    ) {
      const snoozeUntil = new Date(Date.now() + 60 * 60 * 1000); // 1 hour from now
      todoService.snooze(
        annualAccountReport.id,
        WintSuperkollAPIModel.TodoType.AuditorAnnualReportSigningSteps,
        snoozeUntil
      );
    }

    window.open(signingUrl, "_blank");
    dispatch(annualReportSigned(annualAccountReport.id));
  };

  const confirmAuditorReportSigning = async () => {
    await annualAccountService.confirmAuditorReportSigned(
      annualAccountReport.financialYearId,
      props.financialStatementsApprovalSigneePersonId
    );
    dispatch(annualReportSigned(annualAccountReport.id));
  };

  return (
    <PageFooter
      allowForReadOnlyUsers
      actions={[
        annualAccountReport?.auditorState ===
          WintSuperkollAPIModelAnnualAccounts.SuperkollAuditorAnnualReportState.WaitingForAuditReport ||
        annualAccountReport?.auditorState ===
          WintSuperkollAPIModelAnnualAccounts.SuperkollAuditorAnnualReportState.WaitingOnAuditorSign
          ? {
              text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.ConfirmSigning),
              onClick: confirmAuditorReportSigning,
              type: StyleEnums.DisplayType.Info,
              isDisabled: props.disabled,
            }
          : {
              text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.GoToSigning),
              onClick: navigateToSigningPage,
              type: StyleEnums.DisplayType.Info,
              isDisabled: props.disabled,
            },
      ]}
      showNavigateBack={props.showNavigateBack}
      disableSuccessMessages={props.disableSuccessMessages}
    />
  );
};

export default AnnualReportAuditorSigningStepsFooter;
